import * as React from "react";
import ScheduleRow from "./ScheduleRow";
import { WorkSchedule } from "./types";

import "./SchedulesList.css";

interface Props {
  schedules: WorkSchedule[];
  onSelectSchedule: (index: number) => void;
  onToggleScheduleEnabled: (index: number) => void;
  onDeleteSchedule: (schedule: WorkSchedule) => void;
}

export default function SchedulesList(props: Props) {
  return (
    <React.Fragment>
      <div className="schedule-list-grid">
        <span className="week-span">
          <span />
          <span>S</span>
          <span className="week-span-divider" />
          <span>M</span>
          <span className="week-span-divider" />
          <span>T</span>
          <span className="week-span-divider" />
          <span>W</span>
          <span className="week-span-divider" />
          <span>T</span>
          <span className="week-span-divider" />
          <span>F</span>
          <span className="week-span-divider" />
          <span>S</span>
          <span />
        </span>
        <div
          style={{
            gridColumnStart: "actions",
            gridRowStart: 1,
            backgroundColor: "white",
            borderLeft: "1px solid #e4e4e4"
          }}
        />
        {props.schedules.map((x, i) => {
          return (
            <ScheduleRow
              key={i}
              row={i + 2}
              schedule={x}
              onSelectSchedule={() => {
                props.onSelectSchedule(i);
              }}
              onToggleScheduleEnabled={() => {
                props.onToggleScheduleEnabled(i);
              }}
              onDeleteSchedule={() => {
                props.onDeleteSchedule(x);
              }}
            />
          );
        })}
      </div>
    </React.Fragment>
  );
}
